import styled from 'styled-components';

export const ColoredText = styled.span`
  color: ${({ theme }) => theme.colors.green7};
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const UploadText = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.black6};
  margin: 0;
  line-height: 20px;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  color: ${({ theme }) => theme.colors.black6};
  flex-shrink: 0;

  svg {
    fill: currentColor;
  }
`;

export const DropZoneWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 0 4px;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    padding: 0;
  }
`;
